module.exports = __webpack_public_path__ + "img/dell-logo.9159db4f.svg";